import moment from "moment";
import React, { useEffect, useState } from "react";
import Table from "../../components/table/table";
import { Link, useSearchParams } from "react-router-dom";
import { useAppContext } from "../../context/app.context";
import axiosInstance from "../../config/axios";
export function statusMission(status: any) {
  if (status == "enattente") return { title: "En attente", class: "badge-warning" };
  if (status == "annulee") return { title: "Annulée", class: "badge-danger" };
  if (status == "terminée") return { title: "Disponible", class: "badge-success" };
  return { title: "", class: "" };
}
export default function MissionslistPage() {
  const [searchParams] = useSearchParams();
  const { appInfos } = useAppContext();
  const [zones, setzones] = useState<{ label: string; value: string }[]>([]);
  const [loading, setloading] = useState(false);
  const mission = searchParams.get("mission");
  const csvRows = [
    { key: "type", label: "Type" },
    { key: "numFacture", label: "Numéro" },
    { key: "emetteur", label: "Émetteur" },
    { key: "recepteur", label: "Adressée à" },
    { key: "zone.name", label: "Zone franchisée" },
    { key: "priceHT", label: "Prix HT" },
    { key: "priceTTC", label: "Prix TTC" },
    { key: "tvapercent", label: "TVA(%)" },
    { key: "description", label: "Description" },
    { key: "facturationDate", label: "Date de facturation" },
    { key: "created_at", label: "Date de création" },
  ];
  function isAresEmitter(type: string) {
    return type === "commission" || type === "annulation" || type === "ft" || type === "fac";
  }
  function getEmetteur(elt: any) {
    if (isAresEmitter(elt.type)) return "SAS ARÈS";
    if (elt.type === "rémunération" || elt.type === "fvj")
      return (elt?.idJobbeur?.prenom || "") + " " + (elt?.idJobbeur?.nom || "");
    return elt?.idEntreprise?.NomEntreprise;
  }
  function getRcepteur(elt: any) {
    if (isAresEmitter(elt.type)) return elt.idEntreprise?.NomEntreprise;
    if (elt.type === "fvj") return "SAS ARÈS";
    if (elt.type === "rémunération") return elt?.idEntreprise?.NomEntreprise;
    return (elt?.idJobbeur?.prenom || "") + " " + (elt?.idJobbeur?.nom || "");
  }
  const columns = [
    {
      accessorKey: "type",
      filterVariant: "multi-select",
      filterSelectOptions: [
        { label: "rémunération", value: "rémunération" },
        { label: "commission", value: "commission" },
        { label: "FT", value: "ft" },
        { label: "FAC", value: "fac" },
        { label: "FVJ", value: "fvj" },
        { label: "annulation (legacy)", value: "annulation" },
      ],
      header: "Type",
      size: 30,
    },
    {
      accessorKey: "numFacture",
      header: "Numéro",
      size: 30,
    },
    {
      accessorKey: "emetteur",
      header: "Émetteur",
      size: 30,
    },
    {
      accessorKey: "recepteur",
      header: "Adressée à",
      size: 30,
    },
    {
      accessorKey: "zone.name",
      header: "Zone franchisée",
      filterVariant: "multi-select",
      filterSelectOptions: zones,
      size: 30,
    },
    {
      accessorKey: "priceHT",
      header: "Prix HT",
      filterVariant: "range",
      accessorFn: (originalRow: any) =>
        originalRow?.priceHT && !isNaN(+originalRow?.priceHT) ? (+originalRow?.priceHT)?.toFixed(2) : "",
      size: 30,
    },
    {
      accessorKey: "priceTTC",
      filterVariant: "range",
      accessorFn: (originalRow: any) =>
        originalRow?.priceTTC && !isNaN(+originalRow?.priceTTC) ? (+originalRow?.priceTTC)?.toFixed(2) : "",
      header: "Prix TTC",
      size: 30,
    },
    {
      accessorKey: "tvapercent",
      filterVariant: "range",
      header: "TVA(%)",
      size: 30,
    },
    {
      accessorKey: "description",
      header: "Description",
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow.facturationDate),
      header: "Date de facturation",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => moment(+cell.getValue()).format("DD/MM/YYYY"),
      type: "date",
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow.created_at),
      header: "Date de création",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => moment(+cell.getValue()).format("DD/MM/YYYY"),
      type: "date",
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow?.idMission?.created_at),
      header: "Date mission",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => moment(+cell.getValue()).format("DD/MM/YYYY"),
      type: "date",
    },
    {
      accessorKey: "mission",
      header: "Mission",
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ cell }: any) => {
        const mission = cell?.row?.original?.idMission;
        const id = mission?._id || mission;
        const disabled = !id;
        return (
          <Link
            to={"/missions/" + id}
            style={{ pointerEvents: disabled ? "none" : "auto" }}
            // disabled={cell.row.original.status != "terminée"}
            className={`btn btn-secondary btnsmall ${disabled ? "btn-secondary-disabled" : ""}`}
            title="Voir"
          >
            <span>Voir</span>
          </Link>
        );
      },
    },
  ];

  function DownloadFactureBtn(p: any) {
    return (
      <a
        href={
          process.env.REACT_APP_SERVER_URL +
          "/api/factures/facturepdf/" +
          (p.row.original._id || p.row.original.id) +
          "?token=" +
          appInfos.token
        }
      >
        <span className="action">
          <img style={{ marginLeft: 10 }} src="/images/download.svg" alt="télécharger" />
        </span>
      </a>
    );
  }
  function mapData(elt: any) {
    if (!elt.zone?.name && elt.idMission?.zone?.name) {
      elt.zone = elt.idMission.zone;
    }
    if (!elt.zone?.name) {
      elt.zone = { name: "Hors zone" };
    }
    elt.emetteur = getEmetteur(elt);
    elt.recepteur = getRcepteur(elt);
    return elt;
  }

  useEffect(() => {
    (async () => {
      setloading(true);
      try {
        const zoneData = (await axiosInstance.get("/zones")).data;
        const zoneOptions = zoneData.map((elt: any) => ({ value: elt.name, label: elt.name }));
        zoneOptions.unshift({ label: "Hors zone", value: "Hors zone" });
        setzones(zoneOptions);
      } catch (e) {}
      setloading(false);
    })();
  }, []);

  return (
    <Table
      isLoading={loading}
      extracolumnActions={DownloadFactureBtn}
      dataUrl={"factures" + (mission ? "?mission=" + mission : "")}
      columns={columns}
      csvRows={csvRows}
      permission="factures"
      mapData={mapData}
      showExport
      hideDelete
      title="Factures"
      defaultSorting={[{ id: "numFacture", desc: true }]}
    />
  );
}
